export const ORGANIZATION_WALLET = 'organization_wallet';
export const GROUP_WALLET = 'group_wallet';
export const INDIVIDUAL_WALLET = 'individual_wallet';
